export default "__VITE_ASSET__d707454f__"